/// <reference path="../services/session.service.ts" />
/// <reference path="../objects/interfaces/icarinformation.ts" />
/// <reference path="../services/navigation.service.ts" />
/// <reference path="../../wwwroot/scripts/typings/oidc-client.d.ts" />
/// <reference path="../objects/interfaces/ireplacementvehicle.ts" />

module App.Controllers
{
    'use strict'

    export interface IShopcartController extends IBaseController
    {

    }

    export class ShopcartController extends BaseController implements IShopcartController, Interfaces.IStepController
    {
        static controllerId: string = "shopcartController"

        static $inject = [
            '$rootScope',
            '$q',
            '$scope',
            '$timeout',
            Services.NavigationService.serviceId,
            Services.SessionService.serviceId,
            '$state',
            Services.CompositionService.serviceId,
            'ngDialog',
            '$sce',
            Services.ValidationService.serviceId,
            Services.AccountService.serviceId,
            Services.PipelineDataService.serviceId,
            SnackbarFactory.factoryId
        ]

        shopcartCount: number = 0
        products: Interfaces.IProduct[] = []
        shopcartIconVisible = false
        shopcartVisible = false
        isfinished = false
        hasApkInBasket = false
        currentPageName: string
        currentStepNo: number = 1
        currentStepIndex: number = 0
        carInformation: Interfaces.ICarInformation
        stepName: string = 'shopcart'
        carBrand: string
        apkIsValid: boolean = false
        nextApkDate: string
        addApkButton: string = ''
        addedApkButton: string = ''
        licensePlate: string = ''
        selectedReplacementVehicle: App.Interfaces.IReplacementVehicle = null;

        discountCodes: Interfaces.IDiscount[] = []
        selectedDate: string = ''
        selectedTime: string = ''
        selectedStore: string = ''

        currentStep: boolean = false
        customCarDescription: string = ''

        hideSummaryWindow: boolean = false
        loading = false

        totalStepCount: number = 1

        userManager: Oidc.UserManager
        routeKeys = Constants.routeKeys

        question: string = ''
        questionAnswer: string = ''


        constructor(public $rootScope: Interfaces.IAppRootScope,
            $q: ng.IQService,
            public $scope: ng.IScope,
            public $timeout: ng.ITimeoutService,
            public navigationService: Interfaces.INavigationService,
            public sessionService: Interfaces.ISessionService,
            public $state: angular.ui.IStateService,
            composition: Interfaces.ICompositionService,
            ngDialog: any,
            $sce: any,
            validationService: Interfaces.IValidationService,
            accountService: Interfaces.IAccountService,
            public pipelineDataService: Services.IPipelineDataService,
            snackbarFactory: Interfaces.ISnackbarFactory
        )
        {
            super($rootScope, $scope, $q, sessionService, navigationService, composition, ngDialog, $sce, validationService, accountService, snackbarFactory)

            this.addApkButton = $sce.trustAsHtml('APK Toevoegen<i class="fas fa-plus"></i>')
            this.addedApkButton = $sce.trustAsHtml('APK Toevoegd<i class="fas fa-check"></i>')

            this.shopcartIconVisible = Variables.configuratorType == Constants.configuratorTypes.standardProductPipelineName
            if (!Variables.isRdwAvailable)
            {
                (<any>this.$scope).value = this.$sce.trustAsHtml(Variables.rdwUnavailableText)

                this.ngDialog.open({
                    template: 'popupTmpl.html',
                    scope: this.$scope
                })
            }


            if (this.sessionService.composition != null)
            {
                if (this.sessionService.composition.selectedProducts != null) {
                    this.products = this.sessionService.composition.selectedProducts
                }

                if (this.sessionService.composition.products != null) {
                    this.shopcartCount = this.products.length
                }

                if (this.sessionService.composition.carInformation != null) {
                    this.carInformation = this.sessionService.composition.carInformation
                    this.carBrand = this.sessionService.composition.carInformation.brand

                    if (this.sessionService.composition.carInformation.apkIsValid != null) {
                        this.apkIsValid = (this.sessionService.composition.carInformation.apkIsValid && !this.sessionService.composition.unkownLicense)
                    }

                    if (this.sessionService.composition.carInformation.nextApkDate != null) {
                        this.nextApkDate = moment(this.sessionService.composition.carInformation.nextApkDate).format("DD-MM-YYYY")
                    }

                    if (this.sessionService.composition.licensePlate != null) {
                        this.licensePlate = this.sessionService.composition.licensePlate
                    }

                    if (this.sessionService.composition.selectedReplacementVehicle != null) {
                        this.selectedReplacementVehicle = this.sessionService.composition.selectedReplacementVehicle
                    }
                } else {
                    this.apkIsValid = true
                }

                if (this.sessionService.composition.activeDiscounts)
                {
                    this.discountCodes = []
                    this.discountCodes.push(...this.sessionService.composition.activeDiscounts)
                }

                if (this.sessionService.composition.questionTitle && this.sessionService.composition.selectedQuestionOption) {
                    this.question = this.sessionService.composition.questionTitle
                    this.questionAnswer = this.sessionService.composition.selectedQuestionOption.description
                }

                this.setSelectedDateAndTime()

                this.fillCustomCarInformation()
                this.checkApkInProducts()
            }
            
            //Set utm params in store if there are any for the last step to retrieve
            App.Variables.utmParams = App.Functions.getUtmParams(window.location.href)

            this.$rootScope.$on(Constants.broadcast.compositionChange, () =>
            {
                if (this.sessionService.composition.carInformation)
                {
                    this.carInformation = this.sessionService.composition.carInformation
                    this.carBrand = this.sessionService.composition.carInformation.brand

                    if (this.sessionService.composition.carInformation.apkIsValid != null) {
                        this.apkIsValid = (this.sessionService.composition.carInformation.apkIsValid && !this.sessionService.composition.unkownLicense)
                    }

                    if (this.sessionService.composition.carInformation.nextApkDate != null) {
                        this.nextApkDate = moment(this.sessionService.composition.carInformation.nextApkDate).format("DD-MM-YYYY")
                    }
                } else
                {
                    this.apkIsValid = true
                }

                if (this.sessionService.composition != null)
                {
                    if (this.sessionService.composition.licensePlate != null) {
                        this.licensePlate = this.sessionService.composition.licensePlate
                    }
                    
                    this.selectedReplacementVehicle = this.sessionService.composition.selectedReplacementVehicle
                }

                this.fillCustomCarInformation()
                this.setSelectedDateAndTime()

                if (this.sessionService.composition.activeDiscounts)
                {
                    this.discountCodes = []
                    this.discountCodes.push(...this.sessionService.composition.activeDiscounts)
                }

                if (this.sessionService.composition.questionTitle && this.sessionService.composition.selectedQuestionOption) {
                    this.question = this.sessionService.composition.questionTitle
                    this.questionAnswer = this.sessionService.composition.selectedQuestionOption.description
                }

                this.updateProducts()
            })

            this.$scope.$on(Constants.broadcast.shopcartUpdated,
                () =>
                {
                    this.updateProducts()
                })

            var self = this
            $rootScope.$on('$locationChangeStart',
                (event, next, current) =>
                {

                    this.pipelineDataService.getPipelineSteps().then((items) =>
                    {
                        var steps = []

                        for (var item in items)
                        {
                            var state = this.navigationService.getStepByStepName(items[item])
                            if (state != null && state.showInMenu && (steps.filter((x) => x.name == state.name).length == 0))
                            {
                                steps.push(state)
                            }
                        }

                        self.totalStepCount = steps.length
                    }).catch((err) =>
                    {
                        console.log('error loading menu: ' + JSON.stringify(err))
                    })


                    if (self.navigationService && self.navigationService.currentStep())
                    {
                        var curStep = self.navigationService.currentStep()
                        if (curStep != null && curStep.order != null)
                        {
                            self.currentPageName = curStep.name
                            self.currentStepNo = curStep.order

                            self.navigationService.getCurrentStepNumber().then((res) =>
                            {
                                self.currentStepIndex = res

                                this.currentStepInit(res)
                                this.isFinished(res)
                            })
                        }

                    }
                })

            var unregisterFn = $rootScope.$on(Constants.broadcast.validateTimerSet, (event, value: string) =>
            {
                this.loading = !!value
            })

            $scope.$on('$destroy', unregisterFn)
        }

        getExpectYourCarText = () =>
        {
            let text = App.Functions.getExpectYourCarText(this.selectedReplacementVehicle,
                                                            App.Variables.currentSettelmentReplacementVehicleText,
                                                            App.Variables.globalReplacementVehicleText,
                                                            this.sessionService.composition.waitForJob,
                                                            this.selectedTime,
                                                            this.sessionService.composition.pipeline)
            return text
        }

        setSelectedDateAndTime = () =>
        {
            if (this.sessionService.composition.selectedDate)
            {

                let day: string = this.sessionService.composition.selectedDate.toString().substr(8, 2)
                let month: string = this.sessionService.composition.selectedDate.toString().substr(5, 2)
                let year: string = this.sessionService.composition.selectedDate.toString().substr(0, 4)
                this.selectedDate = `${day}-${month}-${year}`
            } else
                this.selectedDate = null

            if (this.sessionService.composition.selectedTime)
                this.selectedTime = this.sessionService.composition.selectedTime
            else
                this.selectedTime = null

            if (this.sessionService.composition.storeSelected)
                this.selectedStore = this.sessionService.composition.storeName
            else
                this.selectedStore = null
        }


        fillCustomCarInformation = () =>
        {
            this.customCarDescription = ''

            if (this.sessionService.composition.licensePlate == '' ||
                this.sessionService.composition.carInformation == null)
            {
                if (this.sessionService.composition.customCarBrand != null)
                {
                    this.customCarDescription = this.sessionService.composition.customCarBrand
                    this.carBrand = this.sessionService.composition.customCarBrand
                }

                if (this.sessionService.composition.customCarModel != null)
                    this.customCarDescription += ' ' + this.sessionService.composition.customCarModel

                if (this.sessionService.composition.customCarFuel != null)
                    this.customCarDescription += ' ' + this.sessionService.composition.customCarFuel
            }
        }

        updateProducts = () =>
        {
            this.products = this.sessionService.composition.selectedProducts

            if (this.products != null) {
                this.shopcartCount = this.products.length
            }

            this.checkApkInProducts()
        }

        removeFromBasketById = (productId, productName) =>
        {
            var products = this.products.filter((p) => { return p.name == productName })

            if (products.length > 0)
            {
                var index = this.products.indexOf(products[0])
                this.products.splice(index, 1)

                var tempComp = this.sessionService.composition
                tempComp.selectedProducts = this.products
                this.sessionService.composition = tempComp

                this.$rootScope.$broadcast(Constants.broadcast.shopcartUpdatedFromCart)
            }

            this.checkApkInProducts()
            this.trackevent('basket', 'click', productName + ' verwijderd uit winkelwagen', productName + ' verwijderd uit winkelwagen')
            $.fancybox.close(true)
        }

        removeFromBasketActieCode = (discountCode: Interfaces.IDiscount) =>
        {
            var discountCodes = this.discountCodes.filter((p) => { return p.code == discountCode.code })

            if (discountCodes.length > 0)
            {
                var index = this.discountCodes.indexOf(discountCodes[0])
                this.discountCodes.splice(index, 1)

                var tempComp = this.sessionService.composition
                tempComp.activeDiscounts = this.discountCodes
                this.sessionService.composition = tempComp

                this.$rootScope.$broadcast(Constants.broadcast.shopcartUpdatedFromCart)
            }

            this.trackevent('basket', 'click', discountCode.code + ' verwijderd uit winkelwagen', discountCode.description + ' verwijderd uit winkelwagen')
        }

        addToApkBasket = () =>
        {
            let selectedProducts = this.sessionService.composition.selectedProducts != null ? this.sessionService.composition.selectedProducts : []
            if (selectedProducts.filter(this.isApkProduct).length === 0)
            {
                const apkProduct = this.sessionService.composition.products.filter(this.isApkProduct)[0]
                if (apkProduct)
                {
                    selectedProducts.push(apkProduct)
                    this.sendProductStatus(false, selectedProducts)
                    this.checkApkInProducts()
                }
            }
        }

        isApkProduct = (product: Interfaces.IProduct) => {
            return product.name.toLowerCase().indexOf(Constants.apkProductSearchPhrase) > -1
        }

        sendProductStatus = (autoContinue: boolean, products: any) =>
        {
            this.setCompositionValue(Constants.apiServiceStateCalls.selectedProducts,
                products,
                autoContinue)
                .then(
                    (result: Classes.IComposition) =>
                    {
                        this.$rootScope.$broadcast(Constants.broadcast.shopcartUpdatedFromCart)
                    }).catch((err) =>
                    {
                        console.log('error setCompositionValue selectedProducts: ' + JSON.stringify(err))
                    }).finally(() =>
                    {

                    })
        }

        toggleShopcart = () =>
        {
            this.shopcartVisible = !this.shopcartVisible
            if (this.shopcartVisible)
            {
                this.trackevent('basket', 'click', 'Open winkelwagen', 'Open winkelwagen')
            } else
            {
                this.trackevent('basket', 'click', 'Sluit winkelwagen', 'Sluit winkelwagen')
            }
        }

        goToProducts = () =>
        {
            this.$state.go(Constants.routeKeys.products, { location: 'replace', reload: true, notify: false })
            this.toggleShopcart()

            this.trackevent('products', 'basket', 'Meer toevoegen aan winkelmand', 'Meer toevoegen aan winkelmand')
        }

        trackevent = (category, action, label, value) =>
        {

        }

        gotoNextStep = () =>
        {
            this.validationService.goToNextStepValidated()
        }

        goBackToStep = () =>
        {
            this.previousStep()
        }

        currentStepInit = (currentStepNumber) =>
        {
            if (currentStepNumber != null)
            {
                if (currentStepNumber != 1)
                    this.currentStep = true
                else
                    this.currentStep = false
            }
        }

        isFinished = (currentStepNumber) =>
        {
            this.isfinished = currentStepNumber == -1
        }

        checkApkInProducts = () =>
        {
            if (this.sessionService.composition.selectedProducts) {
                this.hasApkInBasket = this.sessionService.composition.selectedProducts.filter(this.isApkProduct).length > 0
            }
        }

        toggleOverview = () =>
        {
            this.hideSummaryWindow = !this.hideSummaryWindow
            if (this.hideSummaryWindow)
            {
                $("body").removeClass("overflow-hidden")
            }
            else
            {
                $("body").addClass("overflow-hidden")
                $("body").addClass("overflow-hidden")
            }
        }

        scrollToProduct = (product: any) =>
        {
            var element = document.getElementById("product_" + product.id)
            if (product.id)
            {
                const elementRect = element.getBoundingClientRect()
                const absoluteElementTop = elementRect.top + window.pageYOffset
                const finalPosition = absoluteElementTop - 200

                // Scroll to the calculated position
                window.scrollTo({
                    top: finalPosition,
                    behavior: 'smooth'
                })
            }
        }

        isValid(): boolean { throw new Error("Not implemented") }

        getLicensePlate = () =>
        {
            return App.Functions.setLicensePlateDash(this.licensePlate)
        }

        hasDate() {
            return this.selectedDate != null && this.selectedDate != '' && this.selectedDate != '01-01-0001'
        }

        hasTime() {
            return this.selectedTime != null && this.selectedTime != ''
        }

        ShowReplacementVehicleText() {
            return !this.isWaiting() &&
                    this.selectedReplacementVehicle && this.selectedReplacementVehicle.name &&
                    (this.selectedReplacementVehicle.name != Constants.defaultReplacementVehicleText)
        }

        isWaiting() {
            return this.sessionService.composition.waitForJob;
        }

        showProductsForPipeline() {
            return this.sessionService.composition.pipeline == Constants.configuratorTypes.standardProductPipelineName ||
                this.sessionService.composition.pipeline == Constants.configuratorTypes.tyreChangeDefaultPipelineName
        }
    }

    app.controller(ShopcartController.controllerId, ShopcartController)
}